export const iconFontAwesomeAlphabetJ = (
	<i className="fa-solid fa-j"></i>
);
